class MobileMenu {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const closeButtons = document.querySelectorAll('[data-mobile-menu-close]')
        const openButtons = document.querySelectorAll('[data-mobile-menu-open]')
        const toggleButtons = document.querySelectorAll('[data-mobile-menu-toggle]')
        if (closeButtons.length > 0) {
            closeButtons.forEach((button) => { button.addEventListener('click', (e) => { this.closeMenu(e) }) })
        }
        if (openButtons.length > 0) {
            openButtons.forEach((button) => { button.addEventListener('click', (e) => { this.openMenu(e) }) })
        }
        if (toggleButtons.length > 0) {
            toggleButtons.forEach((button) => { button.addEventListener('click', (e) => { this.toggleMenu(e) }) })
        }
        this._elem.addEventListener('click', (e) => {
            if (e.target === this._elem) {
                this.closeMenu(e)
            }
        })
    }
    openMenu (e) {
        e.preventDefault()
        this._elem.classList.add('active')
        document.body.classList.add('no-scroll')
    }
    closeMenu (e) {
        e.preventDefault()
        this._elem.classList.remove('active')
        document.body.classList.remove('no-scroll')
    }
    toggleMenu (e) {
        e.preventDefault()
        this._elem.classList.toggle('active')
        this._elem.classList.contains('active') ? document.body.classList.add('no-scroll') : document.body.classList.remove('no-scroll')
    }
}

export default MobileMenu



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MobileMenu.js